<template>
  <div class="details-container">
    <b-row>
      <!-- Row -->
      <b-col
        sm="1"
        class="details-column text-sm-right"
      >
        <span>{{ 'name3' | i18n }}:</span>
      </b-col>
      <b-col
        sm="2"
        class="details-column"
      >
        {{ row.item.name3 }}
      </b-col>
      <b-col
        sm="1"
        class="details-column text-sm-right"
      >
        <span>{{ 'tel' | i18n }}:</span>
      </b-col>
      <b-col
        sm="2"
        class="details-column"
      >
        {{ row.item.tel }}
      </b-col>
      <b-col
        sm="1"
        class="details-column text-sm-right"
      >
        <span>{{ 'fax' | i18n }}:</span>
      </b-col>
      <b-col
        sm="2"
        class="details-column"
      >
        {{ row.item.fax }}
      </b-col>
      <b-col
        sm="1"
        class="details-column text-sm-right"
      >
        <span>{{ 'representative' | i18n }}:</span>
      </b-col>
      <b-col
        sm="2"
        class="details-column"
      >
        {{ row.item.representativeNumber }}
      </b-col>
      <!--/ Row END -->
      <!-- Row -->
      <b-col
        sm="1"
        class="text-sm-right details-column"
      >
        <span>{{ 'web_address' | i18n }}:</span>
      </b-col>
      <b-col
        sm="2"
        class="details-column"
      >
        <a
          v-if="row.item.webAddress"
          :href="row.item.webAddress"
          target="_blank"
        >{{ row.item.webAddress }}</a>
      </b-col>
      <b-col
        sm="1"
        class="details-column text-sm-right"
      >
        <span>{{ 'delivery_information_1' | i18n }}:</span>
      </b-col>
      <b-col
        sm="2"
        class="details-column"
      >
        {{ row.item.deliveryInformation1 }}
      </b-col>
      <b-col
        sm="1"
        class="text-sm-right details-column"
      >
        <span>{{ 'evk_price_list' | i18n }}:</span>
      </b-col>
      <b-col
        sm="2"
        class="details-column"
      >
        {{ row.item.evkPriceList }}
      </b-col>
      <b-col
        sm="1"
        class="details-column text-sm-right"
      >
        <span>{{ 'customer_group' | i18n }}:</span>
      </b-col>
      <b-col
        sm="2"
        class="details-column"
      >
        {{ row.item.customerGroup }}
      </b-col>
      <!--/ Row END -->
    </b-row>
  </div>
</template>

<script>
import {BCol, BRow} from 'bootstrap-vue';

export default {
  name: 'CustomersTableDetailsRow',
  components: {'b-row': BRow, 'b-col': BCol},
  props: {
    row: {
      type: Object,
      default: () => {
      }
    }
  }
};
</script>

<style scoped lang="scss">
    ::v-deep   .details-container {
        padding: 10px;
    }

    .details-column {
        padding-right: 8px !important;
        padding-left: 8px !important;
    }

    span {
        color: #7586A5;
    }
</style>
